import React, { useEffect, useState } from "react";
import { object, element, string, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import ProfileMenu from "../../atoms/ProfileMenu";
import ProfileMenuMobile from "../../atoms/ProfileMenuMobile";
import HeaderWrapper from "../../header/header-wrapper";
import WithSSO from "../../with-sso";
import { getUser } from "../../helper/api";

import "./profile-container.m.css";

const ProfileContainer = ({ member, type, authHost, children, sketchesHost, currentPath, hideTopAd = false }) => {
  const [currentMember, setCurrentMember] = useState(member);
  const redirectUrl = `${sketchesHost}${currentPath}`;
  const callbackUrl = sketchesHost;
  const notLoggedInView = () => (
    <div styleName="not-logged-view">
      <WithSSO ssoHost={authHost} signInPath="/sign-in-page" redirectUrl={redirectUrl} callbackUrl={callbackUrl}>
        {({ signInHref }) => (
          <a styleName="button" href={signInHref}>
            Click here to login
          </a>
        )}
      </WithSSO>
    </div>
  );

  useEffect(() => {
    member &&
      getUser().then(resp => {
        setCurrentMember(resp.member);
      });
  }, [member]);

  const loggedInView = () => (
    <React.Fragment>
      <ProfileMenuMobile type={type} />

      <div styleName="wrapper">
        <ProfileMenu type={type} />

        {children}
      </div>
    </React.Fragment>
  );

  return (
    <div styleName="container">
      <HeaderWrapper hideTopAd={hideTopAd} />
      {currentMember && currentMember["verification-status"] ? loggedInView() : notLoggedInView()}
    </div>
  );
};

ProfileContainer.propTypes = {
  member: object,
  type: string.isRequired,
  children: element,
  authHost: string,
  currentPath: string,
  sketchesHost: string,
  hideTopAd: bool
};

const mapStateToProps = state => ({
  member: state.member || null,
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com")
});

export default connect(mapStateToProps, null)(ProfileContainer);
